module.exports = __webpack_public_path__ + "media/images/area/feature/okinawa/related/vi_4-cb2bc610b82d02b6f0e6d3ee854eed0d.jpg";